import { queryOptions } from '@tanstack/react-query'
import { WebsiteRead } from '@/api/dashboard'

import { fetchWebsiteTheme } from './fetchWebsiteTheme'

/**
 * Theme query options.
 * @param gameId
 * @param website
 * @param additionalKey
 * @returns
 */
export const themeQueryOpts = (gameId: string, website: WebsiteRead, additionalKey?: string) =>
  queryOptions({
    queryKey: [gameId, 'token-studio', 'theme', additionalKey],
    queryFn: () => fetchWebsiteTheme(website),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })
